import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'caritas',
  templateUrl: './caritas.component.html',
  styleUrls: ['./caritas.component.scss'],
})
export class CaritasComponent implements OnInit {
  @Input() setPregunta: string
  @Output() valueEmit = new EventEmitter<object>()

  constructor() { }

  ngOnInit() {
  }

  cambioCarita(event) {
    this.valueEmit.emit(event)
  }
}
